import React from "react";
import { Alert, Card, CardBody, Col, Container, Progress, Row } from "reactstrap";

type Props = Readonly<{
  error?: Error;
  progress?: Readonly<{
    current: number;
    total: number;
  }>;
  text: string;
}>;

export const Loading = ({ error, progress, text }: Props) => {
  let progressCurrent = 0;
  let progressTotal = 1;
  if (!error && progress) {
    progressCurrent = progress.current;
    progressTotal = progress.total;
  }
  const percent = Math.floor((progressCurrent / progressTotal) * 100);
  return (
    <Container className="h-100" fluid role="status">
      <Row className="h-100">
        <Col className="align-items-center d-flex h-100" xs={12} sm={{ size: 6, offset: 3 }}>
          <Card className="shadow w-100">
            <CardBody className="text-center">
              <h3>{text}</h3>
              {!error && <div className="d-block m-auto spinner-border" />}
              <div className="pt-2 pb-2">
                {error ? (
                  <>
                    <Alert color="danger">{error.message}</Alert>
                    <small className="d-block">Try reloading the page.</small>
                  </>
                ) : (
                  <Progress animated color="success" max={progressTotal} value={progressCurrent}>
                    {percent}%
                  </Progress>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
